import { useState } from 'react';

const useErrorMessage = () => {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const showError = (message: string) => setErrorMessage(message);
    const clearError = () => setErrorMessage(null);

    return { errorMessage, showError, clearError };
};

export default useErrorMessage;
